<template>
  <section :class="$style.hero">
    <div :class="$style.container">
      <app-image
        :class="$style.image"
        x1="/images/camp/summer-camp-2025-closed.webp"
        x2="/images/camp/summer-camp-2025-closed.webp"
        alt="Summer Camp 2025 Closed"
        webp="/images/camp/summer-camp-2025-closed.webp"
      />
    </div>
  </section>
</template>


<script>
export default {
  name: 'CampHero',
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

$hero-color-left: #ef423c;
$hero-color-right: #f16c43;

.container {
  @extend %container;
  padding-right: 0;
  padding-left: 0;
}

.hero {
  position: relative;
  background: linear-gradient(90deg, #ee403d, #f27043);
  padding-top: 120px;

  @media (max-width: 480px) {
    padding-top: 30px;
  }
}

.image img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/CampHero.vue